<div class="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
    <div class="mb-4 flex justify-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
        <img src="/images/no-wifi.svg" alt="no-wifi" class="w-8 h-8">
      </div>
    </div>
    <h2 class="text-2xl font-semibold text-[#2F4157]">No internet connection</h2>
    <p class="mt-3 text-sm text-gray-600">Please check your connection. Pending requests will retry when you are back online</p>
    <button class="w-[60%] mt-6 rounded-xl bg-[#2F4157] p-2 cursor-pointer text-white" (click)="retryConnection()">
      Retry
    </button>
</div>
